import React, { useState } from 'react' 
import styled from 'styled-components'
import {Container, StyledTitleRight} from './styled'
import './styles.scss'
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';
import 'react-web-tabs/dist/react-web-tabs.css';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import classNames from 'classnames'

const Technologies = props => {
    const [activeTab, setActiveTab] = useState(0)

    const tabStyle ={
        color: ' #a7a2a2',
        fontSize: '1rem',
        fontWeight: 500,
    }

    const tabListStyles = {
        width: '25rem',
        marginRight: '4rem'
    }

    const JsSkills = (
        <TechItem
            text="Over 4 years of experience working with Javascript and web technologies."
            skillIcon = "fas fa-user-ninja"
            skills={['ReactJS', 'ExpressJS', 'NodeJS', 'GraphQL', 'Microservices', 'Serverless']} 
            skillLevel="Ninja"
            pc={90}
        />
    )

    const PythonSkills = (
        <TechItem 
            text="Quite competent solving common and scientific problems with python. Using python's algorithms and data structures
            to work out simple to complex problems."
            skillLevel="Competent"
            pc={80}
            skillIcon="fas fa-user-tie"
            skills={['Web (Flask)', 'GUI (sciter)', 'Scientific(numpy)', 'AI(tensorflow)']}
        />
    )

    const RustSkills = (
        <TechItem
            text="New kid in the block. I have a working knowledge of rust - lifetimes, borrowing and these new concepts introduced, but i still have 
                way more to lean. I've built working parsers and I think that solidified some of the concepts
            "
            skills={['Parsers', 'Semantic analysis', 'Server side (rocket)', 'Data Structures']}
            skillIcon="fas fa-briefcase"
            pc={50}
            skillLevel="Proficient"
        />
    )

    const Devops = (
        <TechItem 
            skillLevel="Proficient"
            skills={['Azure', 'Nginx', 'Docker', 'Ubuntu Server', 'CI/CD', 'Github']}
            text="DevOps - where software development and operations meet to ensure continous integration (CI) and continous development (CD). 
                As a fullstack developer, development and  deployment are a requirement, and I have mastered the tools required to deliver software 
                artifacts to the user 
            "
            skillIcon="fas fa-briefcase"
            pc ={60}
        />
    )

    const Databases = (
        <TechItem 
            skillIcon="fas fa-jedi"
            skillLevel="Jedi"
            skills={['MongoDB', 'Redis', 'Cosmos DB (Azure)', 'Postgresql']} 
            pc={70}
            text="Whether it's data storage or caching, I always have a few db tricks up my sleeves. I totally love mongodb but sometimes user and software
                requirements call for different tools. Anyway, my toolkit is always ready to tackle any data needs that arise
            "
        />
    )

    const getTabContent = () => {
        switch(activeTab){
            case 0:
                return (
                    <div classNames="panel-block is-active">
                        {JsSkills}
                    </div>
                )
            case 1:
                return (
                    <div classNames="pane-block is-active">
                        {PythonSkills}
                    </div>
                )
            case 2:
                return (
                    <div classNames="panel-block is-active">
                        {RustSkills}
                    </div>
                )
            case 3:
                return (
                    <div classNames="panel-block is-active">
                        {Devops}
                    </div>
                )
            case 4: 
                return (
                    <div classNames="panel-block is-active">
                        {Databases}
                    </div>
                )
            default:
                return <div classNames="pane-block is-active">
                    {JsSkills}
                </div>
        }
    }

    const setTab = id => e => {
        e.preventDefault()

        setActiveTab(id)
    }

    return (
        <Container className="has-text-centered container" id="technologies">
            <StyledTitleRight>2. Technologies</StyledTitleRight>

            <TabContent className="has-text-centered is-hidden-mobile ">
                    <Tabs 
                        defaultTab="js"
                        onChange={tabId => console.log(tabId)}
                        vertical={true}
                    >
                        <TabList style={tabListStyles} >
                            <Tab tabFor="js" style={tabStyle}>
                                <span className="icon">
                                    <i className="fab fa-js"></i>
                                </span>
                                <span className="ml-2">Javascript</span>
                            </Tab>
                            <Tab tabFor="python" style={tabStyle}>
                                <span className="icon">
                                    <i className="fab fa-python"></i>
                                </span>
                                <span className="ml-2">Python</span>
                            </Tab>
                            <Tab tabFor="rust" style={tabStyle}>
                                <span className="icon">
                                    <i className="fab fa-rust"></i>
                                </span>
                                <span className="ml-2">Rust</span>
                            </Tab>
                            <Tab tabFor="devops" style={tabStyle}>
                                <span className="icon">
                                    <i className="fas fa-server"></i>
                                </span>
                                <span className="ml-2">DevOps</span>
                            </Tab>
                            <Tab tabFor="dbs" style={tabStyle}>
                                <span className="icon">
                                    <i className="fas fa-database"></i>
                                </span>
                                <span className="ml-2">Databases</span>
                            </Tab>
                        </TabList>
                        <TabPanel tabId="js">
                            <div className="content">
                            {
                                JsSkills
                            }
                            </div>
                        </TabPanel>
                        <TabPanel tabId="python">
                            <div className="content">
                                {PythonSkills}
                            </div>
                        </TabPanel>
                        <TabPanel tabId="rust">
                            <div className="content">
                                {RustSkills}
                            </div>
                        </TabPanel>
                        <TabPanel tabId="devops">
                            <div classNames="content">
                                {Devops}
                            </div>
                        </TabPanel>
                        <TabPanel tabId="dbs">
                            <div classNames="content">
                                {Databases}
                            </div>
                        </TabPanel>
                </Tabs>

            </TabContent>

            <MobileTabs className="is-hidden-tablet panel">
                <div className="panel-tabs">
                    <a href="/" className={classNames(activeTab === 0 && 'is-active')} onClick={setTab(0)}>
                        <span className="icon">
                            <i className="fab fa-js"></i>
                        </span>
                        <span className="ml-2">Javascript</span>
                    </a>
                    <a href="/" className={classNames(activeTab === 1 && 'is-active')} onClick={setTab(1)}>
                        <span className="icon">
                            <i className="fab fa-python"></i>
                        </span>
                        <span className="ml-2">Python</span>
                    </a>
                    <a href="/" className={classNames(activeTab === 2 && 'is-active')} onClick={setTab(2)}>
                        <span className="icon">
                            <i className="fab fa-rust"></i>
                        </span>
                        <span className="ml-2">Rust</span>
                    </a>
                    <a href="/" className={classNames(activeTab === 3 && 'is-active')} onClick={setTab(3)}>
                        <span className="icon">
                            <i className="fas fa-server"></i>
                        </span>
                        <span className="ml-2">DevOps</span>
                    </a>
                    <a href="/" className={classNames(activeTab === 4 && 'is-active')} onClick={setTab(4)}>
                        <span className="icon">
                            <i className="fas fa-database"></i>
                        </span>
                        <span className="ml-2">Databases</span>
                    </a>
                </div>
                {
                    getTabContent()
                }
            </MobileTabs>
        </Container>
        
    )
}

const TechItem = ({pc, text, skillLevel, skillIcon, skills}) => {
    
    const processSkills = arr => {
        //. process the array of skills into twos and store them in levels 
        let levels = []
        let level = []

        arr.forEach((item, idx) => {
            if (idx > 0 && idx % 2 === 1){
                // push the level into levels 
                // create a right level first 
                level.push(
                    <div className="level-right"> 
                        <LevelText>
                            <LevelIcon className="icon mr-2">
                                <i className="fas fa-check"></i>
                            </LevelIcon>
                            <span>{item}</span>
                        </LevelText>
                    </div>
                )

                levels.push(
                    <div className="level is-mobile">
                        {level}
                    </div>
                )
                level = []
            }else{
                level.push(
                    <div className="level-left">
                        <LevelText>
                            <LevelIcon className="icon mr-2">
                                <i className="fas fa-check"></i>
                            </LevelIcon>
                            <span>{item}</span>    
                        </LevelText>
                    </div>
                )
            }
        })

        return levels 
    }
    return (
        <MainTech className="main-tech">
            <Level1 className="level is-mobile">
                <div className="level-left">
                    <Skill>
                        Skill: 
                        <Inset>
                            <span className="icon ml-2">
                                <i className={skillIcon}></i>
                            </span>
                            <span className="ml-2">{skillLevel}</span>
                        </Inset>
                        
                    </Skill>
                </div>
                <div className="level-right">
                <CircularProgressbar 
                    value={pc} 
                    text={`${pc}%`} 
                    styles={{
                        width: '4rem',
                        path: {
                            // color 
                            stroke: `rgb(218, 108, 54, ${pc/100})`
                        },
                        text: {
                            fill: 'rgb(218, 108, 54)'
                        }
                    }}
                />
                </div>
            </Level1>
            <div className="content">
                <ContentText>{text}</ContentText>

                <SkillsList>
                    {processSkills(skills)}
                </SkillsList>
            </div>
        </MainTech>
    )
}

const TabContent = styled.nav `
    margin-top: 3rem;
`

const MobileTabs = styled.nav `
    margin-top: 3rem;
`

const Skill = styled.p `
    font-size: 1.5rem;
    color: #a7a2a2;
    margin-right: 3rem;
`

const Inset = styled.span `
    font-size: 1.3rem;
    color: #da6c36;
`

const MainTech = styled.div `
    width: 100%;
    margin-top: 3rem;
`

const Level1 = styled.div `
    max-width: 10rem;
`

const ContentText = styled.p `
    color: #a7a2a2;
    max-width: 40rem;
    text-align: left;
`

const SkillsList = styled.div `
    max-width: 25rem;
    margin-top: 3rem;
`

const LevelText = styled.p `
    color: #a7a2a2;
`

const LevelIcon = styled.span `
    color: #da6c36;
`

export default Technologies;